export const migrateToV3 = (state)=>state;

//# sourceMappingURL=v3.js.map